import axios from 'axios';
import { headers, getBackOfficeRoute } from './header';
import { ROLE_RENTER } from '../../constants/roles';

const LongLocationTypeApiService = {

  getLongLocationTypes(token) {
    return axios
      .get(`${getBackOfficeRoute(ROLE_RENTER)}/long-location-types`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },
};

export default LongLocationTypeApiService;



// WEBPACK FOOTER //
// ./src/services/api/LongLocationTypeApiService.js